import {
  Directive,
  HostBinding,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgControl, Validators } from '@angular/forms';
import { SubscriptionManager } from '@tmx/core';

@Directive({
  standalone: true,
  selector: '[withValidations]',
})
export class WithValidationsDirective implements OnInit, OnDestroy {
  private readonly control = inject(NgControl);

  @HostBinding('class.is-valid') isValid = false;
  @HostBinding('class.is-invalid') isInvalid = false;
  private readonly sm = new SubscriptionManager();

  @HostListener('blur')
  onBlur() {
    this.updateValidationState();
  }

  ngOnInit() {
    if (this.control.statusChanges) {
      this.sm.manage = this.control.statusChanges.subscribe({
        next: () => {
          this.updateValidationState();
        },
      });
    }
  }

  ngOnDestroy() {
    this.sm.unsubscribe();
  }

  private updateValidationState() {
    const isRequired = Boolean(
      this.control.control?.hasValidator(Validators.required)
    );

    if (isRequired && this.control.value === '') {
      this.isValid = false;
    } else {
      this.isValid = Boolean(this.control.valid) && Boolean(this.control.dirty);
    }

    if (isRequired) {
      this.isInvalid =
        Boolean(this.control.invalid) && Boolean(this.control.touched);
    } else {
      this.isInvalid =
        Boolean(this.control.invalid) &&
        (Boolean(this.control.touched) || Boolean(this.control.dirty));
    }
  }
}
